import { h, Fragment } from "preact";

import formatOdd from "../../../services/odds-format";
import * as I from "../utils/icons"

export function EventHeader({ sport, category, tournament, onClose }) {
	return <div class="fn-tournament-crumb flex h-9 w-full items-center border-b border-harif-950 bg-harif-800 text-white">
		<div class="relative h-full w-9 bg-harif-800 border-r border-harif-950 text-white flex items-center justify-center" onClick={onClose}>
			<I.BackIconLarge class="h-4" />
		</div>
		<div class="px-4 text-sm truncate">
			{sport.name}
			{category == null ? null : <Fragment>
				<span class="px-2 text-xs text-harifzinc-500">/</span>
				{category.name}
			</Fragment>}
			<span class="px-2 text-xs text-harifzinc-500">/</span>
			{tournament.name}
		</div>
	</div>
}
export function EventName({ children }) {
	return <div class="fn-event-crumb flex h-9 w-full items-center justify-between border-b border-harif-950 bg-harif-800 text-white">
		<div class="px-2 text-sm">{children}</div>
	</div>
}
export function EventInfoRow({ children }) {
	return <div class="fn-tournament-crumb flex h-8 w-full items-center justify-between border-b border-harif-950 bg-harif-800 text-white">
		{children}
	</div>
}
export function EventInfoCell({ children }) {
	return <div class="px-2 text-xs">
		{children}
	</div>
}

export function EventNameLarge({ event }) {
	return <div class="fn-event-crumb flex h-12 w-full items-center justify-stretch border-b border-harif-950 bg-harif-800 text-white">
		<div class="w-1/2 min-w-0 grow px-2 text-right text-sm flex items-center justify-end gap-1">
			<I.ShirtSvg class="inline-block h-5 w-5 ml-1" />
			<span>{event.home}</span>
		</div>
		<div class="shrink-0 grow-0 px-2 text-sm">vs</div>
		<div class="w-1/2 min-w-0 grow px-2 text-sm flex items-center gap-1">
			<span>{event.away}</span>
			<I.ShirtSvg class="inline-block h-5 w-5 mr-1" />
		</div>
	</div>
}
export function LiveEventNameLarge({ event }) {
	return <div class="fn-event-crumb flex h-12 w-full items-center justify-stretch border-b border-harif-950 bg-harif-800 text-white">
		<div class="w-1/2 min-w-0 grow px-2 text-right text-sm">{event.home}</div>
		<div class="shrink-0 grow-0">
			<div class="px-3 border border-harifzinc-950 bg-harifzinc-900 rounded text-white h-8 leading-tight flex items-center">
				<span class="text-lg font-bold text-custom-orange-dark w-1/2 grow">{event.current.result[0]}</span>
				<span class="text-sm px-1 pt-px flex-none">:</span>
				<span class="text-lg font-bold text-custom-orange-dark w-1/2 grow">{event.current.result[1]}</span>
			</div>
		</div>
		<div class="w-1/2 min-w-0 grow px-2 text-sm">{event.away}</div>
	</div>
}

export function TabsHScrollContainer({ children }) {
	return <div class="scrollbar-hide h-12 w-full items-stretch overflow-x-auto overflow-y-hidden border-b border-harif-950 bg-harif-800 text-white">
		<div class="flex h-full min-w-full">
			{children}
		</div>
	</div>
}
export function SingleEventTab({ children, onClick, selected = false }) {
	return <div
		data-selected={selected}
		class="flex h-full items-center justify-start whitespace-nowrap border-r border-r-harifzinc-900 px-2 
			data-[selected=true]:bg-amber-500 data-[selected=true]:text-black"
		onClick={onClick}
	>
		<span class="text-sm">{children}</span>
	</div>
}
export function SpecialSingleEventTab({ children, onClick, selected = false }) {
	return <div
		data-selected={selected}
		class="flex h-full items-center justify-start whitespace-nowrap border-r px-2 border-r-dark-teal/80 bg-dark-teal text-slate-50 dark:bg-emerald-800 
				data-[selected=true]:bg-custom-orange data-[selected=true]:text-black data-[selected=true]:border-r-slate-300 
				dark:data-[selected=true]:border-r-slate-800"
		onClick={onClick}
	>
		<span class="text-sm">{children}</span>
	</div>
}

export function EventMarketsMarketGroup({ children }) {
	return <div class="fn-mob-single-event-odds">{children}</div>
}
export function MarketGroup({ children }) {
	return <div class="fn-market-group border-b border-b-harifzinc-700">{children}</div>
}
export function MarketGroupHeader({ onClick, children, open }) {
	return <div class="fn-market-header-row flex h-11 w-full items-center border-b border-harif-950 bg-harif-800 text-white" onClick={onClick}>
		<div class="flex h-full w-9 shrink-0 grow-0 items-center justify-center border-r border-r-harifzinc-900">
			<I.UpArrowIcon class={"h-4 transition-transform " + (open ? '' : 'rotate-180')} />
		</div>
		<div class="truncate px-4 text-sm">{children}</div>
	</div>
}
export function MarketCollapsingElem({ children, open }) {
	return <div class={"overflow-y-hidden transition-all duration-300 " + (open ? 'max-h-749.75' : 'max-h-0')}>
		{children}
	</div>;
}
export function MarketGroupOdds({ children, cols = 3 }) {
	if (cols == 3)
		return <div class="fn-market-odds grid grid-cols-3 bg-harif-900">{children}</div>
	return <div class="fn-market-odds grid grid-cols-2 bg-harif-900">{children}</div>
}
export function MarketGroupOddButton({ outcome, onClick, selected }) {
	if (selected) {
		return <div
			class="flex h-11 items-center justify-between truncate border border-b-harifzinc-950 border-l-harif-800 border-r-harifzinc-950 border-t-harif-800 bg-custom-orange text-white"
			onClick={onClick}
		>
			<div class="truncate px-2 text-xs">{outcome.name}</div>
			<div class="px-2 text-base text-white">{!outcome.value ? '-' : formatOdd(outcome.value)}</div>
		</div>
	}
	return <div
		class="flex h-11 items-center justify-between border border-b-harifzinc-950 border-l-harif-800 border-r-harifzinc-950 border-t-harif-800 bg-harif-900 text-white"
		onClick={onClick}
	>
		<div class="truncate px-2 text-xs">{outcome.name}</div>
		<div class="px-2 text-base text-custom-orange-dark">{!outcome.value ? '-' : formatOdd(outcome.value)}</div>
	</div>
}
export function MarketGroupBetbuilderButton({ outcome, onClick, selected, disabled }) {
	if (disabled) {
		return <div
			class="flex h-11 items-center justify-between truncate border border-slate-400 bg-slate-400 text-slate-600 dark:border-slate-400 dark:bg-slate-200 dark:text-slate-800"
			onClick={onClick}
		>
			<div class="truncate px-2 text-xs">{outcome.name}</div>
			<div class="px-2 text-base"></div>
		</div>
	}
	if (selected) {
		return <div
			class="flex h-11 items-center justify-between truncate border border-slate-800 bg-amber-400 text-black dark:border-slate-800 dark:bg-amber-400 dark:text-black"
			onClick={onClick}
		>
			<div class="truncate px-2 text-xs">{outcome.name}</div>
			<div class="px-2 text-base"></div>
		</div>
	}
	return <div
		class="flex h-11 items-center justify-between border border-slate-200 bg-slate-100 text-slate-950 dark:border-slate-800 dark:bg-slate-900 dark:text-white"
		onClick={onClick}
	>
		<div class="truncate px-2 text-xs">{outcome.name}</div>
		<div class="px-2 text-base text-amber-600 dark:text-amber-400"></div>
	</div>
}

export function FakeSeparator() {
	return <div class="fn-fake-rail h-2 w-full border-b border-harifzinc-900 bg-harif-800"></div>;
}

function SingleEventExample() {
	return <Fragment>
		<EventHeader sport={sport} category={category} tournament={tournament} onClose={() => { }} />
		<EventName>Home - Away</EventName>
		<EventInfoRow>
			<EventInfoCell>Sunday, April 09, 2023</EventInfoCell>
			<EventInfoCell>21:00</EventInfoCell>
		</EventInfoRow>
		<EventNameLarge event={{ teams: { home: { name: "Home" }, away: { name: "Away" } } }} />
		<TabsHScrollContainer>
			<SingleEventTab selected={false} onClick={() => { }}>All</SingleEventTab>
			<SingleEventTab selected={true} onClick={() => { }}>Main</SingleEventTab>
			<SingleEventTab selected={false} onClick={() => { }}>Goals</SingleEventTab>
			<SingleEventTab selected={false} onClick={() => { }}>Handicaps</SingleEventTab>
			<SingleEventTab selected={false} onClick={() => { }}>Half time / Full time</SingleEventTab>
			<SingleEventTab selected={false} onClick={() => { }}>Correct Score</SingleEventTab>
		</TabsHScrollContainer>
		<EventMarketsMarketGroup>
			<MarketGroup>
				<MarketGroupHeader open={true}>Match Result</MarketGroupHeader>
				<MarketGroupOdds>
					<MarketGroupOddButton outcome={{ name: "X", value: 1.20 }} selected={false} />
					<MarketGroupOddButton outcome={{ name: "X", value: 1.20 }} selected={false} />
					<MarketGroupOddButton outcome={{ name: "X", value: 1.20 }} selected={true} />
				</MarketGroupOdds>
			</MarketGroup>
		</EventMarketsMarketGroup>
		<FakeSeparator />
	</Fragment>
}


